<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>
<!-- Main content Start -->
<div class="main-content">
  <!-- Breadcrumbs Start -->
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/4.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">Gallery</h1>
      <ul>
        <li>
          <a class="active" href="index.html">PVKk Degree & P.G </a>
        </li>
        <li>Gallery</li>
      </ul>
    </div>
  </div>
  <!-- Breadcrumbs End -->
  <!-- Events Section Start -->
  <div class="rs-gallery pt-100 pb-100 md-pt-70 md-pb-70">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 mb-30 col-md-6">
          <div class="gallery-item">
            <div class="gallery-img">
              <a class="image-popup" href="assets/images/gallery/1.jpg"><img src="assets/images/gallery/1.jpg" alt=""></a>
            </div>
            <div class="title">
              Group Study Time
            </div>
          </div>
        </div>
        <div class="col-lg-4 mb-30 col-md-6">
          <div class="gallery-item">
            <div class="gallery-img">
              <a class="image-popup" href="assets/images/gallery/2.jpg"><img src="assets/images/gallery/2.jpg" alt=""></a>
            </div>
            <div class="title">
              Examination Hall
            </div>
          </div>
        </div>
        <div class="col-lg-4 mb-30 col-md-6">
          <div class="gallery-item">
            <div class="gallery-img">
              <a class="image-popup" href="assets/images/gallery/3.jpg"><img src="assets/images/gallery/3.jpg" alt=""></a>
            </div>
            <div class="title">
              Final Year Study
            </div>
          </div>
        </div>
        <div class="col-lg-4 mb-30 col-md-6">
          <div class="gallery-item">
            <div class="gallery-img">
              <a class="image-popup" href="assets/images/gallery/4.jpg"><img src="assets/images/gallery/4.jpg" alt=""></a>
            </div>
            <div class="title">
              Online Study
            </div>
          </div>
        </div>
        <div class="col-lg-4 mb-30 col-md-6">
          <div class="gallery-item">
            <div class="gallery-img">
              <a class="image-popup" href="assets/images/gallery/5.jpg"><img src="assets/images/gallery/5.jpg" alt=""></a>
            </div>
            <div class="title">
              Group Solution
            </div>
          </div>
        </div>
        <div class="col-lg-4 mb-30 col-md-6">
          <div class="gallery-item">
            <div class="gallery-img">
              <a class="image-popup" href="assets/images/gallery/6.jpg"><img src="assets/images/gallery/6.jpg" alt=""></a>
            </div>
            <div class="title">
              New Teacher
            </div>
          </div>
        </div>
        <div class="col-lg-4 mb-30 col-md-6">
          <div class="gallery-item">
            <div class="gallery-img">
              <a class="image-popup" href="assets/images/gallery/7.jpg"><img src="assets/images/gallery/7.jpg" alt=""></a>
            </div>
            <div class="title">
              Friendship Forever
            </div>
          </div>
        </div>
        <div class="col-lg-4 mb-30 col-md-6">
          <div class="gallery-item">
            <div class="gallery-img">
              <a class="image-popup" href="assets/images/gallery/8.jpg"><img src="assets/images/gallery/8.jpg" alt=""></a>
            </div>
            <div class="title">
              Covid-19 Fact
            </div>
          </div>
        </div>
        <div class="col-lg-4 mb-30 col-md-6">
          <div class="gallery-item">
            <div class="gallery-img">
              <a class="image-popup" href="assets/images/gallery/9.jpg"><img src="assets/images/gallery/9.jpg" alt=""></a>
            </div>
            <div class="title">
              They Love Eich Other
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 md-mb-30">
          <div class="gallery-item">
            <div class="gallery-img">
              <a class="image-popup" href="assets/images/gallery/10.jpg"><img src="assets/images/gallery/10.jpg" alt=""></a>
            </div>
            <div class="title">
              Computer Science
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 sm-md-30">
          <div class="gallery-item">
            <div class="gallery-img">
              <a class="image-popup" href="assets/images/gallery/11.jpg"><img src="assets/images/gallery/11.jpg" alt=""></a>
            </div>
            <div class="title">
              Group Study & Solution
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="gallery-item">
            <div class="gallery-img">
              <a class="image-popup" href="assets/images/gallery/12.jpg"><img src="assets/images/gallery/12.jpg" alt=""></a>
            </div>
            <div class="title">
              Campus Cruse
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Events Section End -->
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->

</div>
<!-- Main content End --> 

